export default __webpack_public_path__ + "static/media/2.56d12c21.png";